import { Stack, Typography } from '@mui/material';
import React from 'react';
import { NumericFormat } from 'react-number-format';
import { useTheme } from '@mui/system';

function ItemInformation({ item }) {
    const theme = useTheme();

    return (
        <Stack spacing={1.5} p={2} backgroundColor={theme.palette.background.white} borderRadius={1} >
            <Typography variant='heavy'>Item Information</Typography>
            <Typography variant='normal' sx={{ fontSize: '14px' }}><strong>Description: </strong>{item.name ?? item.external_name}</Typography>
            <Typography variant='normal' sx={{ fontSize: '14px' }}><strong>Manufacturer: </strong>{item.vendor.name}</Typography>
            <Typography variant='normal' sx={{ fontSize: '14px' }}><strong>Reference Number: </strong>{item.part_number}</Typography>
            <Typography variant='normal' sx={{ fontSize: '14px' }}><strong>Unit Price: </strong>
                <NumericFormat 
                    value={item.cost / 100}
                    thousandSeparator={true}
                    displayType='text'
                    prefix='$'
                    decimalScale={2}
                    fixedDecimalScale={true}
                />
            </Typography>
            <Typography variant='normal' sx={{ fontSize: '14px' }}><strong>Category: </strong>{item.category ?? item.external_category}</Typography>
        </Stack>
    )
}

export default ItemInformation;